const microservices = {
    SEARCH: 'semantic-search',
    USER: 'user-manager',
    LANGUAGE: 'language-service',
}

const microserviceToUrl = {
    // If REACT_APP_BACKEND_ADDRESS is set, use the direct connection.
    "direct": {
        [microservices.SEARCH]: `${process.env.REACT_APP_BACKEND_ADDRESS}/PROVIDER/search`,
        [microservices.USER]: `${process.env.REACT_APP_BACKEND_ADDRESS}/PROVIDER/user`,
        [microservices.LANGUAGE]: `${process.env.REACT_APP_BACKEND_ADDRESS}/PROVIDER/language`,
    },
    // If it is not set, rely on the server to route traffic.
    "proxy": {
        [microservices.SEARCH]: "/PROVIDER/search",
        [microservices.USER]: "/PROVIDER/user",
        [microservices.LANGUAGE]: "/PROVIDER/language",
    },
}

const getUrl = (microservice, provider) => {
    if (process.env.REACT_APP_BACKEND_ADDRESS) {
        return microserviceToUrl["direct"][microservice].replace('PROVIDER', provider)
    } else {
        return microserviceToUrl["proxy"][microservice].replace('PROVIDER', provider)
    }
}

export { microservices, getUrl }
